import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface INewsCategoriesResponseDto {
    name: string,
    alias: string,
    contentId: number,
    _id: string,
}

/* Получение категорий новостей
    https://master.content-static.sandbox.d2c.r-one.io/docs/#/News%20Categories%20(Deprecated%20Tags)/NewsCategoriesController_readTagList
* */
export const newsCategories = (): IRequest => ({
    uri: '/api/v1/news-categories',
    method: 'GET',
});
